import { envConfig } from '@hc/config';
import { log } from '@hc/logger';
import { httpRequest, queryClient } from '@hc/utils';
import toast from 'react-hot-toast';
import create from 'zustand';

export const constructDrugData = (data) => {
  const allergiesTableData = data.map((val) => ({
    value: val,
    id: val?.id ?? 0,
    lab_test: val?.lab_test ?? '',
    status: val?.is_active ?? false,
    updated_at: val?.updated_at ?? '',
    created_at: val?.created_at ?? '',
  }));
  return allergiesTableData;
};

export const useLabTests = create((set, get) => ({
  labTestData: [],
  labTestCount: 0,
  lab_test_id: '',
  lab_test: '',
  loading: false,
  error: {
    lab_test: '',
  },

  // ------------- STORE METHODS ------------------
  getAllLabTests: async (search = '', limit = 10, offset = 0) => {
    try {
      set({ loading: true });
      const { data } = await queryClient.fetchQuery({
        queryKey: ['getAllLabTests', search, offset],
        queryFn: async () => {
          const response = await httpRequest(
            'get',
            `${envConfig.api_url}/backofficeMaster/lab-test/get/all?search=${search}&limit=${limit}&offset=${offset}`,
            {},
            true
          );
          return response;
        },
        staleTime: Infinity,
      });
      if (data?.status?.code === 200) {
        set(() => ({
          labTestData:
            Array.isArray(data?.data?.lab_test_data) &&
            data?.data?.lab_test_data?.length > 0
              ? constructDrugData(data?.data?.lab_test_data)
              : [],
          labTestCount: data?.data?.lab_test_count,
        }));
      }
      set(() => ({ loading: false }));
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.data?.status?.message ??
          error?.message ??
          '❌ Some thing went wrong plesae try again!'
      );
    }
  },

  labTestsStatusUpdate: async (payload) => {
    try {
      set({ loading: true });
      const { data } = await httpRequest(
        'post',
        `${envConfig.api_url}/backofficeMaster/lab-test/status/update`,
        payload,
        true
      );
      if (data?.status?.code === 200) {
        toast.success(
          data?.status?.message ?? 'Lab Tests Status Updated Successfully'
        );
      }
      set({ loading: false });
      return data?.status?.code;
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.data?.status?.message ??
          error?.message ??
          'Something went wrong please try again!'
      );
    }
  },
  addEditLabTests: async () => {
    const { lab_test, lab_test_id: id } = get();
    const type = id ? 'Update' : 'Add';
    try {
      set({ loading: true });
      const { data } = await httpRequest(
        'post',
        `${envConfig.api_url}/backofficeMaster/lab-test/upsert`,
        { id: id || '', lab_test },
        true
      );
      if (data?.status?.code === 200) {
        toast.success(
          data?.status?.message ?? `Lab Tests Data ${type} Successfully`
        );
      }
      set({ loading: false });
      return data;
    } catch (error) {
      set({ loading: false });
      log('error', error);
      return toast.error(
        error?.data?.status?.message ??
          error?.message ??
          'Something went wrong please try again!'
      );
    }
  },

  handleChange: (value) => {
    set({ lab_test: value });
  },
  isIamValidToSave: () => {
    const { lab_test, error } = get();
    if (!lab_test) {
      error.lab_test = 'Please enter your Lab Tests name';
    } else {
      error.lab_test = '';
      return true;
    }
  },

  initialEditLabTests: (value) => {
    set({
      lab_test: value.lab_test ?? '',
      lab_test_id: value.id ?? '',
    });
  },

  clearlabTestData: () => {
    set({
      lab_test: '',
      lab_test_id: '',
    });
  },
}));
